/**
 * SFrame214 — Finalize Tax Calendar (checklist-only).
 */

import { useParams } from 'react-router-dom';
import SettlementChecklistShell from '../settlement/SettlementChecklistShell';

const FRAME_ID = 'sframe-214';

const ITEMS = [
  {
    id: 'i12-1',
    title: 'Create Tax Deadline Calendar',
    description:
      'List all tax filing deadlines: final 1040, Form 1041, Form 706, and any state returns with their due dates.',
  },
  {
    id: 'i12-2',
    title: 'Assign Tax Professionals',
    description:
      'Confirm which CPA or tax attorney will prepare and file each required return.',
  },
  {
    id: 'i12-3',
    title: 'Upload "Tax Requirement Summary"',
    description:
      'Document your complete list of required filings with responsible parties and deadlines, and upload as a reference.',
  },
];

export default function SFrame214() {
  const { estateId } = useParams<{ estateId: string }>();

  if (!estateId)
    return <div className="max-w-2xl mx-auto py-12 px-4 text-sm text-stone-600">Select an estate.</div>;

  return (
    <SettlementChecklistShell
      estateId={estateId}
      frameId={FRAME_ID}
      title="Finalize Tax Calendar"
      backTo={`/sframe-207/${estateId}`}
      backLabel="← Tax Filings"
      items={ITEMS}
      syncTaxDt4Guided
    />
  );
}
